import { cn } from "@newxsystems/shared";
import type { BlockAlignment } from "@newxsystems/types";
import { BlockRichText } from "../BlockRichText/BlockRichText";
import type { IBlockCommonContentProps } from "./BlockCommonContent.props";

const alignmentClasses: Record<BlockAlignment, string> = {
  start: "items-start text-start",
  center: "items-center text-center",
};

export const BlockCommonContent = ({
  alignment = "start",
  className,
  description,
  eyebrow,
  heading,
  headingLevel: Heading,
}: IBlockCommonContentProps) => {
  if (!eyebrow && !heading && !description) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex min-w-0 max-w-[720px] flex-col",
        alignmentClasses[alignment ?? "start"],
        alignment === "center" && "mx-auto",
        className,
      )}
    >
      {eyebrow ? <p className="mb-5 font-mono text-[12px]/[1.45]">{eyebrow}</p> : null}
      {heading ? (
        <Heading className="max-w-[18ch] text-balance text-[34px]/[1] font-semibold tracking-[-0.025em] [overflow-wrap:anywhere] md:text-[44px]">
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <BlockRichText
          className="mt-6 max-w-[62ch] text-base/[1.55] text-pretty text-onSurface-500 md:text-[17px] [&_a]:underline [&_ol]:ml-5 [&_ol]:list-decimal [&_p+p]:mt-4 [&_ul]:ml-5 [&_ul]:list-disc"
          content={description}
        />
      ) : null}
    </div>
  );
};

BlockCommonContent.displayName = "Shared::BlockCommonContent";
